/**
 * @name vegas sidebar
 * @copyright by vegas s.
 * @date: 27.10.2018
 * @version  1.0
 *
 */

window.vegasSidebar = {
	open: function (self) {
		var $self = $(self),
			target = $self.data('target') || $self.attr('href');

		var $container = $(target);

		$container.addClass('show');

		//console.log(target);

		if (target === '#menu-sidebar') {
			var set = $self.data('set');

			$container.find('.sidebar-body').find('.show').removeClass('show');

			//console.log(set);

			if (set === 'main-menu'){
				$container.find('.mobile-main-navigation').addClass('show');
			} else if (set === 'catalog') {
				$container.find('.mobile-main-catalog').addClass('show');
			}
		}

		return false;
	},
	close: function (self) {
		var $self = $(self);
		var $container = $self.closest('.vg-sidebar');

		$container.removeClass('show');
	}
};

// sidebars
$(document).on('click', '[data-toggle=sidebar-open]', function () {
	vegasSidebar.open(this);
	
	return false;
});

$(document).on('click', '[data-toggle=sidebar-close], .vg-sidebar', function (e) {
	if (e.target !== this) return;
	
	vegasSidebar.close(this);
	
	return false;
});